import { useCallback } from "react";
import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import Select from "../../../../../components/Inputs/Select";
import PayGroupFilters from "../../Topbar/Filters/PayGroupFilters";
import DateFilters from "../../Topbar/Filters/DateFilters";
import { useDateFilters } from "../../../hooks/useDateFilters";

function Header() {
    const { t } = useTranslation();
    const { mode, from, to, setFilters } = useDateFilters();

    const onModeChange = useCallback((mode) => {
        let from, to, payGroupPeriod;
        const now = moment();
        switch (mode) {
            case "date": {
                from = now.toISOString(true);
                to = now.toISOString(true);
                break;
            }
            case "week": {
                from = now.startOf("week").toISOString(true);
                to = now.endOf("week").toISOString(true);
                break;
            }
            case "month": {
                from = now.startOf("month").toISOString(true);
                to = now.endOf("month").toISOString(true);
                break;
            }
            case "custom": {
                from = undefined;
                to = undefined;
                break;
            }
            case "pay-group": {
                from = undefined;
                to = undefined;
                payGroupPeriod = "current";
                break;
            }
            default: {
                from = undefined;
                to = undefined;
                break;
            }
        }
        setFilters({ mode, from, to, payGroup: undefined, payGroupPeriod });
    }, [setFilters]);

    return (
        <Row>
            <Col xs='12' md="auto">
                <Select
                    placeholder={t("mode")}
                    value={mode}
                    onChange={onModeChange}
                    showSearch
                >
                    <Select.Option value="date">
                        {t("date")}
                    </Select.Option>
                    <Select.Option value="week">
                        {t("week")}
                    </Select.Option>
                    <Select.Option value="month">
                        {t("month")}
                    </Select.Option>
                    <Select.Option value="custom">
                        {t("custom")}
                    </Select.Option>
                    <Select.Option value="pay-group">
                        {t("pay-group")}
                    </Select.Option>
                </Select>
            </Col>

            <Col xs='12' md='auto'>
                {mode === "pay-group" ? (
                    <PayGroupFilters />
                ) : (
                    <DateFilters
                        from={from}
                        to={to}
                        mode={mode}
                        setFilters={setFilters}
                    />
                )}
            </Col>
        </Row>
    )
};

export default Header;
